<!-- EF-3852 — maquette « Popin Onboarding » (piste 1a, une page) : en-tête, deux colonnes « Vous » / « Votre société »,
     pied avec « Enregistrer » centré et « Ne plus afficher » à sa droite. Disposition seulement : composants existants. -->
<header class="modal-professional-info__header">
    <eb-h2 class="modal-professional-info__title">{{ 'profile.onboarding.title' | transloco }}</eb-h2>
    <eb-label
        class="modal-professional-info__subtitle"
        color="flat-secondary"
        size="lg"
    >
        {{ 'profile.onboarding.subtitle' | transloco }}
    </eb-label>
</header>

<div class="modal-professional-info__content">
    <eb-profile-professional-info [embedded]="true" />
    <span class="modal-professional-info__separator"></span>
    <eb-profile-company
        [embedded]="true"
        (saved)="onCompanySaved()"
    />
</div>

<footer class="modal-professional-info__footer">
    <button
        eb-button
        data-testid="modal-professional-info-save"
        [disabled]="!canSave()"
        [isV2]="true"
        [outline]="false"
        (click)="save()"
        color="primary-v2"
        size="small"
    >
        {{ 'common.save_changes' | transloco }}
    </button>
    <eb-checkbox-input (checkChange)="onHideChange($event)">
        {{ 'profile.professional_info.dont_show_again' | transloco }}
    </eb-checkbox-input>
</footer>
